export const normalizeClassicLink = url => {
  const a = document.createElement('a');

  a.href = url;

  return a.href.replace(
    /^(https?):\/\/([A-Z\d.-]{2,})\.?([A-Z]{2,})(:\d{2,4})?/i,
    ''
  );
};
